export const notificationState = {
    isLoading: false,
    fontType: [],
    notificationType: [],
    notificationCategory: [],
    notificationList: [],
    errorNumber: 0,
    errorMessage: '',
    messageLabel: '',
     regionList:[],
    statusCode:''

}